import _ from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { APP_IMG, NEXT_PUBLIC_SHOW_LINK_SPECIAL, SHOW_COMMEMORATE } from 'src/constants';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';

const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'), { ssr: false });

const Footer = ({ data, ads }) => {
  const router = useRouter();

  const [salesData, setSalesData] = useState(null);
  const [partnersData, setPartnersData] = useState([]);

  useEffect(async () => {
    try {
      const footer = await GET('/api/footer');
      const company = await GET('/api/v1.0/navigations/company-group');
      if (!_.isEmpty(footer)) setSalesData(footer);
      if (!_.isEmpty(company)) setPartnersData(company);
    } catch (err) {
      console.error(`${timestamp()} ==========> FOOTER ERROR : `, err.message);
    }
  }, []);
  return (
    <>
      {/* AD1X1 IN CONTENT */}
      {router.pathname === '/[cid]' && !_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />}
      {router.pathname === '/[cid]/[id]' && !_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />}

      <FooterWrapper id='footer' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}>
        <section className='footer-wrapper'>
          <div className='container'>
            <div className='grid-wrapper'>
              {/* -------------------------------- BLOCK - 1 ------------------------------- */}
              <div className='block-1'>
                <h3 className='footer-title'>ติดต่อกรุงเทพธุรกิจ</h3>
                {!_.isEmpty(salesData) && (
                  <div
                    className='footer-sale'
                    dangerouslySetInnerHTML={{
                      __html: salesData
                    }}
                  />
                )}
              </div>

              {/* -------------------------------- BLOCK - 2 ------------------------------- */}
              <div className='block-2'>
                <h3 className='footer-title'>หมวดหมู่ข่าว</h3>
                <div className='footer-category'>
                  {!_.isEmpty(data) &&
                    data.map((item, index) => (
                      <a
                        key={index}
                        className='item-category'
                        href={`/${item.link}`}
                        //! DATALAYER
                        onClick={() =>
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'footer',
                            position: 'on:footer',
                            data: {
                              block: '2',
                              title: item?.nameTh,
                              heading: 'หมวดหมู่ข่าว'
                            }
                          })
                        }
                      >
                        {item.nameTh}
                      </a>
                    ))}
                  <a
                    className='item-policy'
                    href='/privacy-policy'
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'footer',
                        position: 'on:footer',
                        data: {
                          block: '2',
                          title: 'นโยบายการเป็นส่วนตัว',
                          heading: 'หมวดหมู่ข่าว'
                        }
                      })
                    }
                  >
                    นโยบายการเป็นส่วนตัว
                  </a>
                </div>
                {/* {NEXT_PUBLIC_SHOW_LINK_SPECIAL && */}
                <div className='kawebook'>
                  <a
                    href={NEXT_PUBLIC_SHOW_LINK_SPECIAL ?? 'https://www.kawebook.com'}
                    target='_blank'
                    rel={'noopener noreferrer follow'}
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'footer',
                        position: 'on:footer',
                        data: {
                          block: '2',
                          title: 'นิยาย by Kawebook',
                          heading: 'พาร์ทเนอร์'
                        }
                      })
                    }
                  >
                    <strong> นิยาย </strong>
                  </a>
                  <span> by KaweBook </span>
                </div>
                {/* } */}
                {/* Shown via CSS on desktop only — avoids useResponsive hydration swap (CLS) */}
                <div className='sonp sonp-desktop'>
                  <a href='https://www.facebook.com/SONPThai/' target='_blank' rel={'noopener noreferrer nofollow'}>
                    <img src={`${APP_IMG}/logo_sonp.png`} alt='sonp' width='210' height='70' />
                  </a>
                </div>
              </div>
              {/* -------------------------------- BLOCK - 3 ------------------------------- */}

              <div className='block-3'>
                <h3 className='footer-title'>พาร์ทเนอร์</h3>
                <div className='footer-category'>
                  {partnersData.map((item, index) => (
                    <a
                      key={index}
                      className='item-partner'
                      href={item.link}
                      target='_blank'
                      rel={'noopener noreferrer nofollow'}
                      //! DATALAYER
                      onClick={() =>
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'footer',
                          position: 'on:footer',
                          data: {
                            block: '3',
                            title: item?.name,
                            heading: 'พาร์ทเนอร์'
                          }
                        })
                      }
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                {/* Shown via CSS on mobile only — avoids useResponsive hydration swap (CLS) */}
                <div className='sonp sonp-mobile'>
                  <a href='https://www.facebook.com/SONPThai/' target='_blank' rel={'noopener noreferrer nofollow'}>
                    <img src={`${APP_IMG}/logo_sonp.png`} alt='sonp' width='210' height='70' />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className='copyright'>
          <span> © {`${new Date().getFullYear()}`} กรุงเทพธุรกิจ มีเดีย จำกัด. All Rights Reserved.</span>
          <span className='truehit' id='truehits_div' />
        </div>
      </FooterWrapper>
    </>
  );
};

export default Footer;

const FooterWrapper = styled.footer`
  .kawebook {
    padding-top: 15px;

    strong {
      font-family: 'DBHelvethaica', sans-serif;
      font-size: 16pt;
      font-weight: 500;
      color: var(--secondary-color);
      padding: 5px;
      &:hover {
        opacity: 0.7;
      }
    }

    span {
      font-family: 'Sarabun', sans-serif;
      font-size: 14px;
      font-weight: normal;
      color: var(--secondary-color);
      font-style: italic;
    }
  }
  .footer-wrapper {
    background-color: var(--black-color);
    padding: 20px 0;
    width: 100%;
    height: 100%;
    .grid-wrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 0px;

      .block-1,
      .block-2,
      .block-3 {
        padding: 0 20px;
      }
      .block-2 {
        border-left: var(--border-default);
        border-right: var(--border-default);
        border-color: rgba(172, 172, 172, 0.3);
        @media (max-width: 767px) {
          border: none;
        }
      }
      @media (max-width: 769px) {
        .block-1,
        .block-2,
        .block-3 {
          padding: 10px;
        }
      }
      @media (max-width: 767px) {
        grid-template-columns: 1fr;
        .block-1,
        .block-2,
        .block-3 {
          padding: 10px;
        }
      }
    }

    .footer-title {
      font-size: 20pt;
      font-weight: 400;
      position: relative;
      margin: 0 0 10px;
      text-transform: uppercase;
      color: #f8f8f8;
      padding-top: 8px;
    }

    .footer-sale {
      p {
        font-weight: 200;
        font-size: 16pt;
        line-height: 1.15;
        color: var(--secondary-color);
        strong {
          color: #f8f8f8;
          font-size: 16pt;
          font-weight: 400;
        }
      }
    }

    .footer-category {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      a {
        cursor: pointer;
        text-decoration: none;
        color: var(--secondary-color);
        font-weight: 200;
        font-size: 16pt;
        line-height: 1.15;
        padding: 5px;
        &:hover {
          opacity: 0.7;
        }
      }
      @media (max-width: 769px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    /* Reserve space for async-fetched footer content so it fills in without shifting (CLS).
     Sized from real data: categories = 13 + policy link (~31px/row), partners = 9.
     Tune these in DevTools if item counts change. */
    .block-2 .footer-category {
      min-height: 250px; /* reserve enough so kawebook + sonp below don't shift when categories load */
    }
    .block-3 .footer-category {
      min-height: 95px; /* 9 items / 3 cols = 3 rows */
    }
    @media (max-width: 767px) {
      .block-1 {
        min-height: 170px; /* title + contact block (dangerouslySetInnerHTML) */
      }
      .block-2 .footer-category {
        min-height: 220px; /* 14 items / 2 cols = 7 rows */
      }
      .block-3 .footer-category {
        min-height: 160px; /* 9 items / 2 cols = 5 rows */
      }
    }

    .sonp {
      text-align: center;
      padding-top: 40px;
    }
    /* CSS-driven visibility replaces useResponsive (isMobile breakpoint = 690px) to avoid layout-shift on hydration */
    .sonp-desktop {
      display: block;
    }
    .sonp-mobile {
      display: none;
    }
    @media (max-width: 690px) {
      .sonp-desktop {
        display: none;
      }
      .sonp-mobile {
        display: block;
      }
    }
  }
  .copyright {
    background: var(--secondary-color);
    position: relative;
    z-index: 1;
    span {
      color: var(--black-color);
      font-size: 16pt;
      font-weight: 400;
      padding: 5px 0;
      display: block;
      text-align: center;
    }
  }
`;
